import { App } from '@cma/app'
import '@helix/styles/dist/helix.css'
import '@lonewolf/aihub-chat/aihub-chat.css'
import { createRoot } from 'react-dom/client'
import './index.css'
import { installLwolfApiNoStoreFetch } from './app/lwolfApiFetch'

installLwolfApiNoStoreFetch()

createRoot(document.getElementById('root') as HTMLElement).render(<App />)
